import { Box } from "@mui/material";
import { HoldStatusConfiguration } from "components";
import { AnimatePresence, motion } from "framer-motion";
import { Control, Path } from "react-hook-form";
import { ContainmentHoldDTO } from "models/dto/containmentHold";
import * as dotEnv from "lib/dotEnv";

interface holdTypeSectionProps {
	/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
	control: Control<any>;
	/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
	initialKey: Path<any>;
	/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
	subsequentKey: Path<any>;
	getHoldOptionDisabled?: (option: ContainmentHoldDTO) => boolean;
	handleSubsequentHoldChange?: (args: { value: ContainmentHoldDTO | null }) => void;
	handleSubsequentDataLoad?: (options: ContainmentHoldDTO[]) => void;
	onInitialDataLoad?: (data: ContainmentHoldDTO[]) => void;
	autoLoadSubsequentHold?: boolean;
	initialDisabled?: boolean;
}

export function HoldTypeSection({
	control,
	initialKey,
	subsequentKey,
	getHoldOptionDisabled,
	handleSubsequentHoldChange,
	handleSubsequentDataLoad,
	onInitialDataLoad,
	autoLoadSubsequentHold,
	initialDisabled,
}: holdTypeSectionProps): React.JSX.Element {
	const cntnmtInitialLoadEnabled = dotEnv.Get("CNTNMT_HLD_INITIAL_ENABLED").Equal("1");

	return (
		<AnimatePresence mode="sync">
			<Box
				component={motion.div}
				initial={{ opacity: 0, height: 0 }}
				animate={{ opacity: 1, height: "auto" }}
				exit={{ opacity: 0, height: 0 }}
				transition={{ duration: 0.3 }}
				style={{ overflow: "visible" }}
			>
				<HoldStatusConfiguration
					control={control}
					initialKey={initialKey}
					subsequentKey={subsequentKey}
					autoLoadIntialHold={!cntnmtInitialLoadEnabled}
					autoLoadSubsequentHold={autoLoadSubsequentHold}
					onInitialDataLoad={!cntnmtInitialLoadEnabled ? onInitialDataLoad : undefined}
					getOptionDisabled={getHoldOptionDisabled}
					onChange={handleSubsequentHoldChange}
					onSubsequentDataLoad={handleSubsequentDataLoad}
					initialDisabled={initialDisabled}
				/>
			</Box>
		</AnimatePresence>
	);
}
